import React, {Component} from 'react';
import PropTypes from 'prop-types';
import BackEnd from "../../../../backend/BackEnd";
import ActionLink from "../../../../controls/ActionLink";
import FileIcon from "../../../../utils/components/FileIcon";
import FileUploader from "../../../../components/FileUploader";
import PdfViewerModal from "../../../../modals/PdfViewerModal";
import ImageViewerModal from "../../../../modals/ImageViewerModal";
import {successToast} from "../../../../utils/toasts";
import ConfirmationModal from "../../../../modals/ConfirmationModal";

const $ = window.jQuery;

class Document extends Component {

}

class DocumentList extends Component {
    static propTypes = {
        documents: PropTypes.array.isRequired,
        entityId: PropTypes.number.isRequired,
        entityName: PropTypes.string.isRequired,
        propertyName: PropTypes.string.isRequired,
        onUpload: PropTypes.func.isRequired
    };
    static defaultProps = {};
    state = {
        showPdfViewerModal: false,
        showImageViewerModal: false,
        showDocumentDeletionConfirmationModal: false,
        currentDocumentId: null,
        currentDocumentName: null,
        selectedDocuments: [],
        documents: this.props.documents
    };

    componentWillReceiveProps(nextProps) {
        this.setState({documents: nextProps.documents});
    }

    render() {
        return (
            <div>
                <div className="clearfix p-a-1">
                    <button type="button" className="btn btn-primary btn-sm m-r-1"
                            onClick={() => this.fileUploader.open()}>
                        <i className="fa fa-upload"/> Прикрепить
                    </button>
                    <div className="pull-right">
                        {
                            this.state.selectedDocuments.length > 0 &&
                            <button type="button" className="btn btn-default btn-sm m-r-1"
                                    onClick={() => this.downloadSelected()}>
                                Скачать выделенные
                            </button>
                        }
                        {
                            this.state.documents.length > 0 &&
                            <button type="button" className="btn btn-default btn-sm"
                                    onClick={() => this.downloadAll()}>
                                <i className="fa fa-cloud-download"/> Скачать все
                            </button>
                        }
                    </div>
                </div>
                {this.state.documents.map(document =>
                    <div key={document.id} className="widget-messages-item unread">
                        {/*<label className="widget-messages-checkbox custom-control custom-checkbox custom-control-blank">*/}
                            {/*<input type="checkbox" className="custom-control-input" />*/}
                            {/*<span className="custom-control-indicator"/>*/}
                        {/*</label>*/}
                        <ActionLink className="widget-messages-from" style={{width: '100%', maxWidth: '100%'}}
                                    onClick={() => this.downloadOrOpenDocument(document)}>
                            <FileIcon extension={document.extension}/> {document.name}
                        </ActionLink>
                        {
                            document.canDelete &&
                            <div className="widget-messages-date">
                                <button type="button" className="btn btn-danger btn-outline btn-xs"
                                        onClick={() => this.deleteDocument(document)}>
                                    <i className="fa fa-times"/>
                                </button>
                            </div>
                        }
                    </div>
                )}
                <FileUploader ref={el => this.fileUploader = el}
                              entityId={this.props.entityId}
                              entityName={this.props.entityName}
                              propertyName={this.props.propertyName}
                              onUpload={() => this.props.onUpload()}/>
                <PdfViewerModal documentId={this.state.currentDocumentId}
                                show={this.state.showPdfViewerModal}
                                onHide={() => this.setState({showPdfViewerModal: false})}/>
                <ImageViewerModal documentId={this.state.currentDocumentId}
                                  show={this.state.showImageViewerModal}
                                  onHide={() => this.setState({showImageViewerModal: false})}/>
                <ConfirmationModal show={this.state.showDocumentDeletionConfirmationModal}
                                   onConfirm={() => this.confirmDeleteDocument()}
                                   onHide={() => this.setState({showDocumentDeletionConfirmationModal: false})}>
                    После удаления документа не будет возможности его восстановления.
                    {' '}
                    Вы действительно хотите удалить документ {this.state.currentDocumentName}
                </ConfirmationModal>
            </div>
        );
    }

    async downloadOrOpenDocument(document) {
        if (document.extension === ".pdf") {
            this.setState({
                showPdfViewerModal: true,
                currentDocumentId: document.id
            });
        }
        else if (document.extension === ".jpg" || document.extension === ".jpeg") {
            this.setState({
                showImageViewerModal: true,
                currentDocumentId: document.id
            });
        }
        else {
            let getFileToken = new BackEnd.Tokens.GetFileToken();
            let token = await getFileToken.call();

            let downloadFile = new BackEnd.Documents.Download();
            let href = downloadFile.createUrl({documentId: document.id, token});

            $('<a />').attr({href, download: 'download'}).get(0).click();
        }
    }

    deleteDocument(document) {
        this.setState({
            showDocumentDeletionConfirmationModal: true,
            currentDocumentId: document.id,
            currentDocumentName: document.name
        });
    }

    async confirmDeleteDocument() {
        let deleteDocumentEndpoint = new BackEnd.Documents.DeleteDocument();
        let result = await deleteDocumentEndpoint.call({
            documentId: this.state.currentDocumentId
        });

        if (result.success) {
            successToast(`Документ ${this.state.currentDocumentName} успешно удалён`);
            this.props.onUpload();
        }
    }

    downloadSelected() {
        if (this.state.selectedDocuments.length) {

        }
    }

    async downloadAll() {
        const {entityId, entityName, propertyName} = this.props;

        let getFileToken = new BackEnd.Tokens.GetFileToken();
        let token = await getFileToken.call();

        let downloadFilesPackage = new BackEnd.Documents.DownloadFilesPackage();
        let href = downloadFilesPackage.createUrl({
            entityId,
            entityName,
            propertyName,
            token
        });

        $('<a />').attr({href, download: 'download'}).get(0).click();
    }
}

export default DocumentList;


// WEBPACK FOOTER //
// ./src/pages/TenderBlock/Tenders/components/DocumentList.js